
export default {
  //  免责声明页面
  name: 'Disclaimer',
  components: {},
  layout: 'template-page',
  head() {
    return {
      title: '免责声明_问卷网',
    }
  },
  methods: {
    // 跳转路由
    jump(url, query) {
      this.$href(url, query)
    },
  },
}
